import { combineReducers } from 'redux';

import flash from './flash';
import locale from './locale';
import simbot from './simbot';
import site from './site';
import user from './user';
import version from './version';

export default combineReducers({
  flash,
  locale,
  simbot,
  site,
  user,
  version,
});
